export interface StaticPageMenuSource {
  slug: string;
  title: string;
}

export interface InformationMenuItem {
  slug: string;
  title: string;
  href: string;
  children: InformationMenuItem[];
}

function normalizeSlug(slug: string): string {
  return slug.replace(/\\/g, "/").replace(/^\/+|\/+$/g, "");
}

/** Builds the two menu levels beneath the singular Information header entry. */
export function buildInformationMenu(pages: StaticPageMenuSource[]): InformationMenuItem[] {
  const normalized = pages
    .map((page) => ({ ...page, slug: normalizeSlug(page.slug) }))
    .filter((page) => page.slug && page.title.trim());

  const roots = normalized.filter((page) => !page.slug.includes("/"));

  return roots.map((root) => ({
    slug: root.slug,
    title: root.title,
    href: `/info/${root.slug}`,
    children: normalized
      .filter((page) => {
        const segments = page.slug.split("/");
        return segments.length === 2 && segments[0] === root.slug;
      })
      .map((page) => ({
        slug: page.slug,
        title: page.title,
        href: `/info/${page.slug}`,
        children: [],
      })),
  }));
}
